import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useMounted } from 'src/hooks/use-mounted';

const useListStore = (searchState, handleApi = async () => {}) => {
  const isMounted = useMounted();
  const fetchedState = useRef({
    page: 0,
    query: null,
    rows: 0,
    hasFetched: false,
  });

  const pageOffset = searchState.page;
  const keywordQuery = searchState.filters.query;
  const rowsPerPage = searchState.rowsPerPage;

  // Memoize the payload to avoid unnecessary re-calculation
  const payload = useMemo(() => {
    const payloadObj = {
      limit: rowsPerPage,
      offset: pageOffset * rowsPerPage,
    };

    if (keywordQuery) payloadObj.keyword = keywordQuery;

    return payloadObj;
  }, [pageOffset, rowsPerPage, keywordQuery]);

  const handleListGet = useCallback(
    async (page) => {
      await handleApi(payload, isMounted);
    },
    [handleApi, payload, isMounted], // Only re-run if `payload` changes
  );

  useEffect(() => {
    if (
      fetchedState.current.query !== keywordQuery ||
      fetchedState.current.page !== pageOffset ||
      fetchedState.current.rows !== rowsPerPage
    ) {
      // Reset when query, page, or rowsPerPage changes
      fetchedState.current.hasFetched = false;
      fetchedState.current.query = keywordQuery;
      fetchedState.current.page = pageOffset;
      fetchedState.current.rows = rowsPerPage;
    }

    // If data has already been fetched, avoid refetching
    if (!fetchedState.current.hasFetched) {
      handleListGet(fetchedState.current.page);
      fetchedState.current.hasFetched = true;
    }
  }, [keywordQuery, pageOffset, rowsPerPage, handleListGet]); // Only depend on relevant values

  return { fetchedState };
};

const useListIds = (arrays = []) => {
  return useMemo(() => {
    return arrays.map((item) => item.id);
  }, [arrays]);
};

export { useListStore, useListIds };
